import { render, staticRenderFns } from "./AnswerSuggestionFormControl.vue?vue&type=template&id=03b4f746&"
import script from "./AnswerSuggestionFormControl.vue?vue&type=script&lang=js&"
export * from "./AnswerSuggestionFormControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports